// extracted by mini-css-extract-plugin
module.exports = {"closingOverlay":"ClosingOverlay_closingOverlay__1Wu-s","darken":"ClosingOverlay_darken__3nBHZ"};